import { render, staticRenderFns } from "./GeneralSettingsCheckoutEnableRequestedDelivery.vue?vue&type=template&id=356e9e84&"
import script from "./GeneralSettingsCheckoutEnableRequestedDelivery.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsCheckoutEnableRequestedDelivery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports